import { Injectable } from '@angular/core';
import { Network } from '@capacitor/network';
import { Store } from '@ngrx/store';
import * as AppActions from './../store/actions/app.actions';

@Injectable({
  providedIn: 'root'
})
export class CapacitorNetworkService {

  constructor(private store: Store<{}>) { }

  init() {
    Network.addListener('networkStatusChange', status => {
      console.log('Network status changed', status);
      this.store.dispatch({ type: AppActions.setIsOffline.type, isOffline: !status.connected });
    });
  }
}
